module.exports = __webpack_public_path__ + "static/media/sample-club-with-player-count.144479e0.png";